import { FormControlLabel, Switch } from '@material-ui/core';
import React, { Component } from 'react';

import {Link} from "react-router-dom";

import "../index.css";

import {Header as StHeader} from "../repo/footer/standard/standard";
import LIGHT_LOGO from "../assets/reanime-circle-name-image-transparent-compressed.png"
import DARK_LOGO from "../assets/reanime-circle-name-image-transparent-dark-compressed.png"

class Header extends Component {
    
    render() {

        const ThemeColor = (this.props.darkTheme) ? "white" : "black";
        const PrimaryColor = "red";

        const Logo = <div id="header_logo_container">
            <Link to="/">
               <img src={(ThemeColor == "white") ? DARK_LOGO : LIGHT_LOGO} alt="Logo"/>
            </Link>
        </div>

        const HeaderLinks = [
            <FormControlLabel
                id="theme_switch"
                key={0}
                control={<Switch style={{color:PrimaryColor}} size="medium" checked={this.props.darkTheme} onChange={this.props.toggleTheme} />}
            />,
            <Link key={1} className={(window.location.pathname === "/") ? "selected" : "unselected"} to="/">Home</Link>,
        ]

        return (
            <StHeader
                mobileMenuOption={false}
                logo={Logo}
                boxShadowColor="lightgray"
                boxShadowColorDark="black"
                borderColor="black"
                borderColorDark="white"
                backgroundColor="white"
                backgroundColorDark="#1b1b1b"
                primaryColor="red"
                links={HeaderLinks}
                theme={(!this.props.darkTheme)}
            />
        );
    }
}
 
export default Header;